import { useTranslation } from 'react-i18next';

const faqData = [
  {
    questionKey: 'pricing.faq.questions.planSwitching.question',
    answerKey: 'pricing.faq.questions.planSwitching.answer',
  },
  {
    questionKey: 'pricing.faq.questions.dataEncryption.question',
    answerKey: 'pricing.faq.questions.dataEncryption.answer',
  },
  {
    questionKey: 'pricing.faq.questions.searchDifference.question',
    answerKey: 'pricing.faq.questions.searchDifference.answer',
  },
  {
    questionKey: 'pricing.faq.questions.spacesLimit.question',
    answerKey: 'pricing.faq.questions.spacesLimit.answer',
  },
  {
    questionKey: 'pricing.faq.questions.dataAfterCancel.question',
    answerKey: 'pricing.faq.questions.dataAfterCancel.answer',
  },
  {
    questionKey: 'pricing.faq.questions.refunds.question',
    answerKey: 'pricing.faq.questions.refunds.answer',
  },
  {
    questionKey: 'pricing.faq.questions.bookmarkExport.question',
    answerKey: 'pricing.faq.questions.bookmarkExport.answer',
  },
  {
    questionKey: 'pricing.faq.questions.aiFeatures.question',
    answerKey: 'pricing.faq.questions.aiFeatures.answer',
  },
  {
    questionKey: 'pricing.faq.questions.browserExtension.question',
    answerKey: 'pricing.faq.questions.browserExtension.answer',
  },
];

const FAQSection = () => {
  const { t } = useTranslation();

  return (
    <section className="faq-section py-5">
      <div className="container">
        <div className="row justify-content-center mb-5">
          <div className="col-lg-8 text-center">
            <h3 className="h2 fw-bold mb-3">
              {t('pricing.faq.title')}
            </h3>
            <p className="lead text-muted">
              {t('pricing.faq.subtitle')}
            </p>
          </div>
        </div>

        <div className="row justify-content-center">
          {faqData.map((faq, index) => (
            <div key={index} className="col-lg-4">
              <h5 className="fw-bold faq-question mb-3">{t(faq.questionKey)}</h5>
              <p className="faq-answer text-muted">{t(faq.answerKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export { faqData };
export default FAQSection;
